import React from "react";
import { connect } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import LocaleStrings from "../../../../languages/index.js";
import { Fragment } from "react";
import {
  BaseComponent,
  LABEL_POSITION_TOP,
} from "../../../../../common/base-component";
import { XIcon } from "@heroicons/react/outline";
import { Field, reduxForm } from "redux-form";
import moment from "moment-timezone";
import { postReplySuggestion, fetchAppsuggestion } from "../../actions/index";
import { Toaster } from "react-hot-toast";
import "react-phone-input-2/lib/material.css";
import _ from "lodash";
import { NotificationManager } from "react-notifications";
import TicketModalMedia from "../Tickets/ticket-modalmedia";
import { classNames } from "../../../../../common/common-functions";

class SuggestionReplyModal extends BaseComponent {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      alertMessage: "",
      showerror: false,
      loading: false,
      btnLoader: false,
    };

    // All Binded Functions
  }

  onSubmitForm(data) {
    this.setState({ btnLoader: true });
    var reply = data.reply;
    var suggestionid = this.props.Reply_tosuggestion.id;

    this.props.postReplySuggestion(
      this.props.session,
      reply,
      suggestionid,
      (response) => {
        if (response.success === 0) {
          NotificationManager.error(LocaleStrings.common_wentWrong);
        } else {
          this.props.onClose();
          this.props.fetchAppsuggestion(
            this.props.session,
            "suggestions",
            10,
            this.props.currentPage,
            "listing",
            "",
            (CallBackResponse) => {}
          );

          NotificationManager.success(
            LocaleStrings.ticketsReports_Repliedssuccessfully
          );
        }
      }
    );
  }

  renderList() {
    var items = _.map(this.props.data.media, (values) => (
      <TicketModalMedia key={values.userid} values={values} />
    ));
    // console.log('check', this.state.pageNumber);
    return items;
  }

  render() {
    var { data } = this.props;
    let tabledate = "";
    tabledate = moment(data.reportedby.createdon).format("D MMM YYYY HH:mm A");
    var { handleSubmit, pristine, reset, submitting, invalid } = this.props;
    return (
      <>
        <Transition.Root show={this.props.isOpen} as={Fragment}>
          <Dialog
            as="div"
            static
            className="fixed z-10 inset-0 overflow-y-auto"
            initialFocus={this.myRef}
            open={this.props.isOpen}
            onClose={this.props.onClose}>
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0">
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true">
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                  <div className="grid gap-4  grid-cols-2  border-b-2 border-gray-50 pb-4">
                    {/* <div></div> */}
                    <div className="flex flex-wrap ml-2">
                      {LocaleStrings.ticketsReports_replyModalappsuggestion}
                    </div>
                    <div className="flex flex-wrap content-center justify-end">
                      <button
                        type="button"
                        className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
                        onClick={this.props.onClose}
                        ref={this.myRef}>
                        <span className="sr-only"></span>
                        <XIcon className="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                  <form
                    className="space-y-8 divide-y divide-gray-200 mt-5"
                    onSubmit={handleSubmit(this.onSubmitForm.bind(this))}
                    encType="multipart/form-data">
                    <div>
                      <div className="flex">
                        <p>{LocaleStrings.ticketsReports_Reportedby}</p>
                        <p className="px-2">{data.reportedby.username}</p>
                      </div>
                      <div className="text-ternary my-2">{tabledate}</div>
                      <div className="flex">{this.renderList()}</div>

                      <p className="my-4">
                        {LocaleStrings.ticketsReports_feedback}
                        {_.startCase(data.feedback)}
                      </p>
                      <div className="flex mb-5">
                        <p>{LocaleStrings.ticketsReports_Reportedon}</p>
                        <p className="px-2">{data.email}</p>
                      </div>
                      <div className="mb-5">
                        <Field
                          name="reply"
                          label="Reply Text"
                          placeholder="Reply Text"
                          mandatory="false"
                          component={this.renderAllfields}
                          maxlength={200}
                          labelposition={LABEL_POSITION_TOP}
                          classNameLabel="text-box-lable"
                          className="py-3 px-4 block w-full shadow-sm text-secondary focus:ring-primary focus:border-teal-500 border border-warm-gray-300 rounded-md"
                        />
                      </div>
                      <div className="center-item pt-8">
                        <button
                          //   onClick={}
                          type="submit"
                          className="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-700 ">
                          <svg
                            className={classNames(
                              this.state.btnLoader ? "" : "sr-only",
                              "animate-spin-medium h-5 w-5 rounded-full mx-2"
                            )}
                            viewBox="0 0 1024 1024"
                            focusable="false"
                            data-icon="loading"
                            width="1em"
                            height="1em"
                            fill="currentColor"
                            aria-hidden="true">
                            <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                          </svg>
                          {LocaleStrings.common_send}
                        </button>
                      </div>
                      <div className="center-item my-4">
                        {LocaleStrings.ticketsReports_longText}
                      </div>
                    </div>
                  </form>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>

        <Toaster limit={1} />
      </>
    );
  }
}
function validate(values) {
  var errors = {};

  var requiredFields = ["reply"];
  requiredFields.forEach((field) => {
    if (!values[field] || values[field].trim() === "") {
      errors[field] = "Required";
    }
  });

  return errors;
}

function mapStateToProps(state, ownProps) {
  var { session, user } = state;
  // console.log("session", state.Reply_tosuggestion);
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    Reply_tosuggestion: state.Reply_tosuggestion,
    data: ownProps.data,
  };
}

export default connect(mapStateToProps, {
  postReplySuggestion,
  fetchAppsuggestion,
})(
  reduxForm({
    validate,
    form: "SuggestionReplyModal",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(SuggestionReplyModal)
);
